import { createApi } from '@reduxjs/toolkit/query/react';
import { ReauthBaseQuery, authApiBaseQuery } from '@skynet/data-auth-api';

// Empty API to use as a base for code generation
// Uses the auth base query with automatic token refresh
export const baseApi = createApi({
  reducerPath: 'profileApi',
  baseQuery: ReauthBaseQuery(authApiBaseQuery),
  endpoints: () => ({}),
});
